import {
  QuickLinkLabel,
  StaffNavigationComponent,
} from '../../../components/staff/staff-navigation/staff-navigation.component';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DirectiveModule } from '../../../shared/directives/directive.module';
import { MaterialModule } from '../../../shared/modules/material.module';
import { PipesSharedModule } from '../../../shared/pipes/pipes.module';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { IFrameComponent } from '../../../components/iframe/iframe.component';
import { StaffContentComponent } from '../../../components/staff/staff-content/staff-content.component';
import { AnnouncementsBannerModule } from '../../../components/announcements-banner/announcements-banner.module';

@NgModule({
  imports: [
    CommonModule,
    DirectiveModule,
    MaterialModule,
    PipesSharedModule,
    FormsModule,
    FlexLayoutModule,
    AnnouncementsBannerModule,
  ],
  declarations: [StaffContentComponent, IFrameComponent, StaffNavigationComponent, QuickLinkLabel],
  exports: [StaffContentComponent, IFrameComponent, StaffNavigationComponent, QuickLinkLabel],
})
export class LegacyStaffModule {}
